module.exports = __webpack_public_path__ + "05282d3f2fa4cd26c6dd037cfdfd04c7.svg";